import React, { useState } from "react";
import CampoBuscarClub from "../../UI/campos/CampoBuscarClub.js";
import ComboSelector from "../../UI/campos/ComboSelector.js";
import CuadroDatos from "../../UI/CuadroDatos.js";
import * as TipoRival from "../../constantes/TipoRival.js";
import { PreFiltro } from "../../data/DataClubes.js";
import * as Funciones from "../../funciones/FuncionesHistoriales.js";
import styles from "./SelectorRival.module.css";

const SelectorRival = (props) => {
  const club = props.club;
  const [tipoRival, setTipoRival] = useState(Funciones.EncontrarRival(TipoRival.CLUB));
  const [clubRival, setClubRival] = useState(null);
    
  const onTipoRivalElegido = (tipoElegido) => {
    setTipoRival(tipoElegido);
  }

  const onClubElegido = (campo, clubElegido) => {
    if (clubElegido) {
      setClubRival(clubElegido);
      const tipoElegido = Funciones.EncontrarRival(campo);
      if (tipoElegido) {
        props.onRivalElegido(tipoElegido, clubElegido);
      }
    }
  }

  return (
    <CuadroDatos titulo="Rival" isCargando={false} errores={false}>
      <div className={`${styles.contenedor}`}>
        <span className={`${styles.titulo}`}>Tipo Rival</span>
        <ComboSelector
          lista={Funciones.TiposRival}
          valorActual={tipoRival}
          campoClave={"id"}
          campoDescripcion={"descripcion"}
          isCargando={false}
          onItemElegido={onTipoRivalElegido}
        />
        {tipoRival.id === TipoRival.CLUB && (
          <React.Fragment>
            <span className={`${styles.titulo}`}>Club Rival</span>
            <CampoBuscarClub
              prefiltro={PreFiltro.CLUB_RIVAL}
              objetoFiltro={club}
              nombre={TipoRival.CLUB}
              valor={clubRival}
              editar={true}
              width="100%"
              onClubElegido={onClubElegido}
            />
          </React.Fragment>
        )}
      </div>
    </CuadroDatos>
  );
};

export default SelectorRival;
